import { Outlet } from 'react-router-dom';
import { AppSidebar } from '@/components/navbar/app-sidebar';
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import { NotificationBell } from '@/components/notification-bell';
import { ThemeToggle } from '@/components/theme-toggle';
import { PageTitleProvider, usePageTitle } from '@/hooks/use-page-title';

function DashboardHeader() {
  const { pageTitle } = usePageTitle();
  const Icon = pageTitle.icon;

  return (
    <header className="flex h-12 shrink-0 items-center gap-3 border-b px-4">
      <div className="flex items-center gap-2 min-w-0 flex-1">
        {Icon && <Icon className="h-5 w-5 shrink-0 text-muted-foreground" />}
        {pageTitle.title && (
          <h1 className="text-xl font-semibold tracking-tight truncate">{pageTitle.title}</h1>
        )}
      </div>
      <ThemeToggle />
      <NotificationBell />
      <img
        src="https://pub-1ff2bfc848e3479d9b3ca8fc80c9d1aa.r2.dev/public/logo-inline.png"
        alt="SocialFlows"
        className="h-6 shrink-0 block dark:hidden"
      />
      <img
        src="https://pub-1ff2bfc848e3479d9b3ca8fc80c9d1aa.r2.dev/public/logo-inline-dark.png"
        alt="SocialFlows"
        className="h-6 shrink-0 hidden dark:block"
      />
    </header>
  );
}

export default function DashboardLayout() {
  return (
    <PageTitleProvider>
      <SidebarProvider defaultOpen={false}>
        <AppSidebar />
        <SidebarInset>
          <DashboardHeader />
          <Outlet />
        </SidebarInset>
      </SidebarProvider>
    </PageTitleProvider>
  );
}
